import shippingServiceFormHtml from './shippingServiceForm.component.html';

class ShippingServiceFormController {
    constructor(ShippingServiceService, $scope) {
        'ngInject';

        this.service = ShippingServiceService;
        this.$scope = $scope;
    }

    submit() {
        this.service.submit().then(() => {
            if (typeof this.onSent === 'function') {
                this.onSent();
            }
        });
    }

    submitWithError() {
        this.service.showAllErrors = true;
    }
}

let shippingServiceFormComponent = {
    bindings: {
        onSent: '&?'
    },
    template: shippingServiceFormHtml,
    controller: ShippingServiceFormController
};

export default shippingServiceFormComponent;